module.exports = __webpack_public_path__ + "static/body-bg-56de6a6f26853b9d0cf185f15472adc1.jpg";